<template>
    <select :disabled="readonly" v-model="displayValue" class="form-control" title="Tipo Pessoa">
        <option v-for="sn in onezero" :value="sn.value" v-bind:key="sn.value">{{ sn.name }}</option>
    </select>
</template>
<script>
export default {
    props: {
        value: {
            default: false
        },
        readonly: {
            default: false
        }
    },
    data() {
        return {
            onezero: [
                { value: 1, name: "Janeiro" },
                { value: 2, name: "Fevereiro" },
                { value: 3, name: "Março" },
                { value: 4, name: "Abril" },
                { value: 5, name: "Maio" },
                { value: 6, name: "Junho" },
                { value: 7, name: "Julho" },
                { value: 8, name: "Agosto" },
                { value: 9, name: "Setembro" },
                { value: 10, name: "Outubro" },
                { value: 11, name: "Novembro" },
                { value: 12, name: "Dezembro" }
            ]
        };
    },
    computed: {
        displayValue: {
            get: function() {
                return this.value;
            },
            set: function(modifiedValue) {
                this.$emit("input", modifiedValue);
            }
        }
    }
};
</script>
